// Tremor Raw Tooltip [v0.0.1]
"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import * as TooltipPrimitives from "@radix-ui/react-tooltip";
import { cx } from "../../lib/utils";
const Tooltip = React.forwardRef((_a, forwardedRef) => {
    var { children, className, content, delayDuration, defaultOpen, open, onClick, onOpenChange, showArrow = true, side, sideOffset = 10, triggerAsChild = false } = _a, props = __rest(_a, ["children", "className", "content", "delayDuration", "defaultOpen", "open", "onClick", "onOpenChange", "showArrow", "side", "sideOffset", "triggerAsChild"]);
    return (React.createElement(TooltipPrimitives.Provider, { delayDuration: 150 },
        React.createElement(TooltipPrimitives.Root, { open: open, defaultOpen: defaultOpen, onOpenChange: onOpenChange, delayDuration: delayDuration },
            React.createElement(TooltipPrimitives.Trigger, { onClick: onClick, asChild: triggerAsChild }, children),
            React.createElement(TooltipPrimitives.Content, Object.assign({ ref: forwardedRef, side: side, sideOffset: sideOffset, align: "center", className: cx(
                // base
                "onvo-max-w-60 onvo-select-none onvo-rounded-md onvo-px-2.5 onvo-py-1.5 onvo-text-sm onvo-leading-5 onvo-shadow-md", 
                // text color
                "onvo-text-gray-50 dark:onvo-text-gray-900", 
                // background color
                "onvo-bg-gray-900 dark:onvo-bg-gray-50", 
                // transition
                "onvo-will-change-[transform,opacity]", "data-[side=bottom]:onvo-animate-slideDownAndFade data-[side=left]:onvo-animate-slideLeftAndFade data-[side=right]:onvo-animate-slideRightAndFade data-[side=top]:onvo-animate-slideUpAndFade data-[state=closed]:onvo-animate-hide", className) }, props),
                content,
                showArrow ? (React.createElement(TooltipPrimitives.Arrow, { className: "onvo-border-none onvo-fill-gray-900 dark:onvo-fill-gray-50", width: 12, height: 7, "aria-hidden": "true" })) : null))));
});
Tooltip.displayName = "Tooltip";
export { Tooltip };
//# sourceMappingURL=Tooltip.js.map